// extracted by mini-css-extract-plugin
export default {"status":"styles_status__9BbkZ","name":"styles_name__r66sc","tabToTop":"styles_tabToTop__NWGbw","sort":"styles_sort__M8POq","default":"styles_default__k2YKY"};